module.exports = __webpack_public_path__ + "static/img/m1.327a615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m1.png
// module id = aS/Q
// module chunks = 12